"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixedToolbarButtons = FixedToolbarButtons;
var _react = _interopRequireWildcard(require("react"));
var _plateBasicMarks = require("@udecode/plate-basic-marks");
var _plateCommon = require("@udecode/plate-common");
var _emojiDropdownMenu = require("./emoji-dropdown-menu");
var _markToolbarButton = require("./mark-toolbar-button");
var _toolbar = require("./toolbar");
var _listToolbarButton = require("./list-toolbar-button");
var _plateList = require("@udecode/plate-list");
var _actionItemToggleButton = require("./action-item-toggle-button");
var _Icon = require("../../forecast-v2/components/media/icon/Icon");
var _turnIntoDropdownMenu = require("./turn-into-dropdown-menu");
var _useElementWidth = require("../../hooks/useElementWidth");
var _linkToolbarButton = require("./link-toolbar-button");
var _jsxRuntime = require("react/jsx-runtime");
/* Manually installed - commented out the menus we do not need so we don't have to manually install those do not override */
/* eslint-disable react/jsx-pascal-case */

/*
import {ListStyleType} from '@udecode/plate-indent-list';
import {ELEMENT_IMAGE} from '@udecode/plate-media';
import {MARK_BG_COLOR, MARK_COLOR} from '@udecode/plate-font';

import { AlignDropdownMenu } from '@/components/plate-ui/align-dropdown-menu';
import { ColorDropdownMenu } from '@/components/plate-ui/color-dropdown-menu';
import { CommentToolbarButton } from '@/components/plate-ui/comment-toolbar-button';
import { IndentListToolbarButton } from '@/components/plate-ui/indent-list-toolbar-button';
import { IndentToolbarButton } from '@/components/plate-ui/indent-toolbar-button';
import { LineHeightDropdownMenu } from '@/components/plate-ui/line-height-dropdown-menu';

import { MediaToolbarButton } from '@/components/plate-ui/media-toolbar-button';
import { MoreDropdownMenu } from '@/components/plate-ui/more-dropdown-menu';
import { OutdentToolbarButton } from '@/components/plate-ui/outdent-toolbar-button';
import { TableDropdownMenu } from '@/components/plate-ui/table-dropdown-menu';
import {TurnIntoDropdownMenu} from './turn-into-dropdown-menu';
import {InsertDropdownMenu} from './insert-dropdown-menu';
import {ModeDropdownMenu} from './mode-dropdown-menu';
import {IndentListToolbarButton} from './indent-list-toolbar-button';
*/
function FixedToolbarButtons(_ref) {
  var pluginToggles = _ref.pluginToggles;
  var readOnly = (0, _plateCommon.useEditorReadOnly)();
  var toolbarRef = (0, _react.useRef)(null);
  var toolbarWidth = (0, _useElementWidth.useElementWidth)(toolbarRef);
  var compact = !!(toolbarWidth && toolbarWidth <= 550);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "w-full overflow-hidden",
    ref: toolbarRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-wrap",
      style: {
        transform: 'translateX(calc(-1px))'
      },
      children: [!readOnly && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [pluginToggles.paragraphStyles && /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarGroup, {
          noSeparator: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_turnIntoDropdownMenu.TurnIntoDropdownMenu, {
            compact: compact
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_toolbar.ToolbarGroup, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_markToolbarButton.MarkToolbarButton, {
            tooltip: "Bold (\u2318+B)",
            nodeType: _plateBasicMarks.MARK_BOLD,
            "data-cy": 'bold-button',
            "data-testid": 'bold-button',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'bold'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_markToolbarButton.MarkToolbarButton, {
            tooltip: "Italic (\u2318+I)",
            nodeType: _plateBasicMarks.MARK_ITALIC,
            "data-cy": 'italic-button',
            "data-testid": 'italic-button',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'italics'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_markToolbarButton.MarkToolbarButton, {
            tooltip: "Underline (\u2318+U)",
            nodeType: _plateBasicMarks.MARK_UNDERLINE,
            "data-cy": 'underline-button',
            "data-testid": 'underline-button',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'underline'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_markToolbarButton.MarkToolbarButton, {
            tooltip: "Strikethrough (\u2318+\u21E7+M)",
            nodeType: _plateBasicMarks.MARK_STRIKETHROUGH,
            "data-cy": 'strikethrough-button',
            "data-testid": 'strikethrough-button',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'strikethrough'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_markToolbarButton.MarkToolbarButton, {
            tooltip: "Code (\u2318+E)",
            nodeType: _plateBasicMarks.MARK_CODE,
            "data-cy": 'mark-code-button',
            "data-testid": 'mark-code-button',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'code'
            })
          })]
        }), pluginToggles.link && /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarGroup, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_linkToolbarButton.LinkToolbarButton, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_toolbar.ToolbarGroup, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_listToolbarButton.ListToolbarButton, {
            nodeType: _plateList.ELEMENT_UL,
            "data-cy": 'unordered-list-button',
            "data-testid": 'unordered-list-button'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_listToolbarButton.ListToolbarButton, {
            nodeType: _plateList.ELEMENT_OL,
            "data-cy": 'ordered-list-button',
            "data-testid": 'ordered-list-button'
          }), pluginToggles.todoList && /*#__PURE__*/(0, _jsxRuntime.jsx)(_actionItemToggleButton.ActionItemToggleButton, {
            "data-cy": 'action-item-button',
            "data-testid": 'action-item-button'
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarGroup, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_emojiDropdownMenu.EmojiDropdownMenu, {
            "data-cy": 'emoji-button',
            "data-testid": 'emoji-button'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "grow"
      })]
    })
  });
}